import _Interval from './model';
import create from './create';

export const Interval = _Interval;

Interval.create = create;

export default Interval;



// WEBPACK FOOTER //
// ./domain/Interval/index.js